export const all = 'ppms/all';
export const website = 'ppms/app';
export const metaSite = 'ppms/meta-site';
